import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.css';
import './assets/styles/styles.scss'
import Main from "./features/Main/view/Main";
import AppSettingController from "./features/Main/controller/AppSettingController";
import * as Sentry from "@sentry/react";
import './i18n';

Sentry.init({
    dsn: "https://e38154fedd70e502b64cd97dba8667de@sentry.netbee.online/3",
    sendDefaultPii: true,
    debug: true,
    normalizeDepth: 10,
    sampleRate: 1.0,
    tracesSampleRate: 1.0,
    denyUrls: [],
});

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <Main/>
        </BrowserRouter>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
AppSettingController.initServiceWorker();
reportWebVitals();
